import { cn } from '@/lib/utils';
import type { DecayCurve } from '@/lib/decay';
import { getTierColor, getTierLabel } from '@/lib/decay';

interface DecayBarProps {
  curve: DecayCurve;
  progress: number;
  currentTierIndex: number | null;
}

export function DecayBar({ curve, progress: _progress, currentTierIndex }: DecayBarProps) {
  const totalMinutes = curve.expiresAfterMinutes;

  return (
    <div className="w-full">
      <div className="flex h-3 w-full overflow-hidden rounded-full">
        {curve.tiers.map((tier, index) => {
          const widthPercent =
            ((tier.toMinutes - tier.fromMinutes) / totalMinutes) * 100;
          const isActive = index === currentTierIndex;
          const isPast =
            currentTierIndex !== null && index < currentTierIndex;
          const color = getTierColor(index);

          return (
            <div
              key={index}
              className={cn(
                'transition-opacity duration-300',
                isPast && 'opacity-30',
                isActive && 'animate-pulse',
              )}
              style={{
                width: `${widthPercent}%`,
                backgroundColor: color,
              }}
            />
          );
        })}
      </div>
      <div className="mt-1.5 flex">
        {curve.tiers.map((tier, index) => {
          const widthPercent =
            ((tier.toMinutes - tier.fromMinutes) / totalMinutes) * 100;

          return (
            <span
              key={index}
              className={cn(
                'text-center text-[10px] font-medium',
                index === currentTierIndex
                  ? 'text-white'
                  : 'text-gray-500',
              )}
              style={{ width: `${widthPercent}%` }}
            >
              {getTierLabel(index)}
            </span>
          );
        })}
      </div>
    </div>
  );
}
